export const SETTINGS = "settings";
export const ROOT = "root";
export const DATA_ROOT = "data-root";
export const TEAM_USER_MANAGEMENT = "team-user-management";